import Child from './child';
import Address from './../address';
import * as R from 'ramda';

export default function DeathDeclaration(data){
    let representing = data || {};
    let professions = [];
    if(!R.isNil(representing.professionalSituation)){
        if(!Array.isArray(representing.professionalSituation)){
            let allProfs = representing.professionalSituation.split(',');
            if(Array.isArray(allProfs)){
                allProfs.forEach(p => {professions.push(p.trim())});
            }
            else{
                professions.push(allProfs);
            }
    
        }
    }
    
    this.id = representing.id;
    this.processNumber = representing.processNumber;

    this.deathDate = R.isNil(representing.deathDate) ? undefined : representing.deathDate === '0001-01-01T00:00:00Z' ? undefined: new Date(representing.deathDate);
    this.allocations = R.isNil(representing.allocations) ? [] : representing.allocations;
    this.houseHoldCount = representing.houseHoldCount;
    this.isDeathRelatedToActivity = representing.isDeathRelatedToActivity;
    this.onBoardingStep = representing.onBoardingStep;
    this.hasChildren = representing.hasChildren;
    this.childrens = R.isNil(representing.childrens) ? [] : representing.childrens.map(c => new Child(c));

    this.email = representing.email;
    this.phoneNumber = representing.phoneNumber;
    this.gender = representing.gender === 1 || representing.gender === '1' ? 'Female'
        : representing.gender === 2 || representing.gender === '2' ? 'Male'
        : representing.gender;
    this.firstName = R.isNil(representing.firstName) ? "" : representing.firstName;
    this.lastName = R.isNil(representing.lastName) ? "" : representing.lastName;
    this.birthDate = R.isNil(representing.birthDate) ? undefined : representing.birthDate === '0001-01-01T00:00:00Z' ? undefined: new Date(representing.birthDate);
    this.birthPlace = representing.birthPlace;
    this.departmentNumber = representing.departmentNumber;
    this.country = representing.country;
    this.civilStatus = representing.civilStatus;
    this.professionalSituation = professions;
    this.isInvalid = representing.isInvalid;
    this.partnerId = representing.partnerId;
    this.etablissementId = representing.etablissementId;

    this.userId = representing.userId;
    this.declaringUserId = representing.declaringUserId;
    this.diedInActivityId = representing.diedInActivityId;
    this.userDeceasedAddress = new Address(representing.userDeceasedAddress);
    this.userResidenceAddress = new Address(representing.userResidenceAddress);
    
}